

const sleep = (t) => new Promise((r) => setTimeout(r, t));

export function swiperInit() {
	var defaultSettingSwiper = {
		observer: true,
		observeParents: true,
		rewind: true,
		speed: 1205,
		loop: false,
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
	};
	var textSwiperBanner = new Swiper(".swiper-text-sync .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			476: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			},

		},
		speed: 1205,
		lazy: {
			loadPrevNext: true,
		},
	});

	var primarySwiper = new Swiper(".primary-banner .swiper", {
		spaceBetween: 0,
		centeredSlides: true,
		speed: 1205,
		rewind: true,
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: false,
			disableOnInteraction: false,
		},
		lazy: {
			loadPrevNext: true,
		},

		thumbs: {
			swiper: textSwiperBanner,
		},

	});


	var homeEvent = new Swiper(".home-event .swiper", {
		spaceBetween: 20,
		slidesPerView: 1,
		speed: 1205,
		lazy: {
			loadPrevNext: true,
		}, pagination: {
			el: ".home-event  .swiper-pagination",
			type: "fraction",
		},
		navigation: {
			nextEl: ".home-event .next",
			prevEl: ".home-event .prev",
		},
	});


	var swiperGrid = new Swiper(".grid-swiper .swiper", {
		autoplay: {
			delay: 5000,
			pauseOnMouseEnter: true,
		},
		lazy: {
			loadPrevNext: true,
		},
		observer: true,
		spaceBetween: 15,
		observeParents: true,
		breakpoints: {
			200: {
				slidesPerView: 2,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			576: {
				slidesPerView: 3,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			768: {
				slidesPerView: 3,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 4,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1200: {
				slidesPerView: 5,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
		},

		navigation: {
			nextEl: ".grid-swiper .next",
			prevEl: ".grid-swiper .prev",
		},
	});


	var partnerSwiper = new Swiper(".partner-swiper .swiper", {
		loop: true,
		speed: 4000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 6,
			},
			1200: {
				spaceBetween: 20,
				slidesPerView: 8,
			},
			1400: {
				spaceBetween: 20,
				slidesPerView: 9,
			},
		},
	});

	$(".init-swiper .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-init-" + index);
		$this
			.parents(".init-swiper")
			.find(".prev")
			.addClass("prev-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".next")
			.addClass("next-nav-" + index);
		$this
			.parents(".init-swiper")
			.find(".swiper-pagination")
			.addClass("pagination-inst-" + index);

		var swiper = new Swiper(".swiper-init-" + index, {
			...defaultSettingSwiper,
			slidesPerView: "auto",
			navigation: {
				nextEl: ".next-nav-" + index,
				prevEl: ".prev-nav-" + index,
			},
			pagination: {
				el: ".pagination-inst-" + index,
				type: "fraction",

			},
		});
	});





	$(".home-news .swiper").each(function (index) {
		var $this = $(this);
		$this.addClass("swiper-news-" + index);
		$this
			.parents(".tab-item")
			.find(".prev")
			.addClass("prev-nav-news-" + index);
		$this
			.parents(".tab-item")
			.find(".next")
			.addClass("next-nav-news-" + index);
		var swiper = new Swiper(".swiper-news-" + index, {
			...defaultSettingSwiper,
			spaceBetween: 20,
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				576: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1200: {
					spaceBetween: 20,
					slidesPerView: 4,
				},
				1600: {
					spaceBetween: 48,
					slidesPerView: 3.8,
				},
			},
			navigation: {
				nextEl: ".next-nav-news-" + index,
				prevEl: ".prev-nav-news-" + index,
			},

		});
	});


	var stickyNavSwiper = new Swiper(".swiper-sticky-nav .swiper", {
		// Optional parameters
		preventInteractionOnTransition: true,
		slideToClickedSlide: true,
		slidesPerView: "auto",
		freeMode: true,
		spaceBetween: 0,
		speed: 705,
		lazy: {
			loadPrevNext: true,
		},
		navigation: {
			nextEl: ".swiper-sticky-nav .next",
			prevEl: ".swiper-sticky-nav .prev",
		},
	});


	var historyThumb = new Swiper(".history-thumb .swiper", {
		spaceBetween: 20,

		breakpoints: {
			200: {
				spaceBetween: 0,
				slidesPerView: 3,
			},
			576: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 5,
			},
			1200: {
				slidesPerView: 6,
			},
			1400: {
				slidesPerView: 7,
			},
		},
		speed: 300,
		noSwiping: true,

		lazy: {
			loadPrevNext: true,
		},
	});
	var historyMain = new Swiper(".history-main .swiper", {
		spaceBetween: 40,
		centeredSlides: true,
		speed: 1205,
		slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		slideToClickedSlide: true,
		lazy: {
			loadPrevNext: true,
		},

		navigation: {
			nextEl: ".history-main .next",
			prevEl: ".history-main .prev",
		},
		thumbs: {
			swiper: historyThumb,
		},
	});


	var progressSwiper = new Swiper(".progress-swiper .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				spaceBetween: 15,
				slidesPerView: 1,
			},
			768: {
				spaceBetween: 20,
				slidesPerView: 2,
			},

			1200: {
				spaceBetween: 40,
				slidesPerView: 2.4,
			},

		},
		loop: true,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		pagination: {
			el: ".progress-swiper .swiper-pagination",
			type: "progressbar",
		},
		navigation: {
			nextEl: ".progress-swiper .next",
			prevEl: ".progress-swiper .prev",
		},
		speed: 800,
	});



	var aboutUsSwiper = new Swiper(".about-us-swiper .swiper", {
		spaceBetween: 20,
		breakpoints: {
			200: {
				spaceBetween: 15,
				slidesPerView: 1,
			},
			768: {
				spaceBetween: 20,
				slidesPerView: 2,
			},

			1200: {
				spaceBetween: 40,
				slidesPerView: 2.2,
			},

		},
		loop: false,
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		speed: 800,
	});
}